<template>
  <button class="button" :disabled="disableBtn">
    <Spinner v-if="loading" />
    <slot v-else></slot>
  </button>
</template>

<script setup>
import { computed } from 'vue';
import Spinner from '@nuxt-common/atomic-ui/app/components/spinner/Spinner.vue';

// Define props
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

// Computed property for disabling button
const disableBtn = computed(() => props.loading || props.disabled);
</script>

<style scoped>
.spinner-loader {
  filter: brightness(0) invert(1);
}
</style>
